import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { Check } from "lucide-react";

const Verticals = () => {
  const { t } = useI18n();
  return (
    <section id="pour-qui" className="bg-white border-t border-slate-200 scroll-mt-20" data-testid="verticals-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 section">
        <div className="max-w-2xl">
          <span className="accent-bar" />
          <p className="eyebrow mb-3">{t.verticals.eyebrow}</p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            {t.verticals.title}
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">{t.verticals.lead}</p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {t.verticals.items.map((it, i) => (
            <div key={i} className="card p-5 flex items-start gap-3" data-testid={`vertical-${i}`}>
              <Check size={18} className="text-[#016C36] mt-0.5 shrink-0" />
              <span className="text-sm font-medium text-slate-800">{it}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Verticals;
